export class HandleResolverError extends Error {
  name = 'HandleResolverError'
}
